module.exports = __webpack_public_path__ + "static/pluginNo-4abb3f0ca427ec5828b8b09e000b4d1c.png";